import '../social_content_following_comments_view.js.coffee'
Monitoring.Views ||= {}

class Monitoring.Views.GoogleMyBusinessContentFollowingCommentsView extends
Monitoring.Views.SocialContentFollowingCommentsView

  buildQuery: =>
    @searchQuery = new Monitoring.Models.SearchQuery({}, {use_defaults: false})
    @searchQuery.addGMBParentReviewId(@rootParentId)
    @searchQuery.addContextKind('gmb_following_comments')
    @addContextLimit()
    dateFrom = Date.create(@socialContent.created_at()).getTime()
    @searchQuery.addDateFrom(dateFrom)
    @searchQuery.setNowDate(true)
    @searchQuery.addExcludedContentId(@socialContent.externalId())
